export const rooms = [
  {
    id: 1,
    title: "Deluxe Double Bedded Room",
    subtitle: "2 adults",
    img: "/deluxe-double-bedded-room/ddbr11.webp",
    description: "This elegant two-bedded room at our heritage hotel, nestled in the heart of Chowrasta, offers timeless charm with vintage furnishings and modern amenities. Overlooking the hotel’s lush gardens, the room combines historic elegance with serene comfort, providing a peaceful retreat in the vibrant town center.",
    amenities: [
      "Comfortable beds with fresh linens",
      "Clean blankets & pillows",
      "Attached bathroom with hot & cold running water",
      "Basic toiletries",
      "Television",
      "Free Wi-Fi",
      "Electric kettle (for boiling water only)",
      "Complimentary drinking water",
      "Rooms with views (mall road / garden / hill – subject to availability)",
      "Daily housekeeping",
      "Room heater available (on request / chargeable)"
    ],
    images: [
      "/deluxe-double-bedded-room/ddbr11.webp",
      "/deluxe-double-bedded-room/ddbr1.webp",
      "/deluxe-double-bedded-room/ddbr2.webp",
      "/deluxe-double-bedded-room/ddbr3.webp",
      "/deluxe-double-bedded-room/ddbr4.webp",
      "/deluxe-double-bedded-room/ddbr5.webp",
      "/deluxe-double-bedded-room/ddbr6.webp",
      "/deluxe-double-bedded-room/ddbr7.webp",
      "/deluxe-double-bedded-room/ddbr8.webp",
      "/deluxe-double-bedded-room/ddbr9.webp",
      "/deluxe-double-bedded-room/ddbr10.webp",
      "/deluxe-double-bedded-room/ddbr12.webp"
    ],
    detailedDescription: [
      "This elegant two-bedded room at our heritage hotel, nestled in the heart of Chowrasta, offers timeless charm with vintage furnishings and modern amenities. Overlooking the hotel’s lush gardens, the room combines historic elegance with serene comfort, providing a peaceful retreat in the vibrant town center."
    ],
    price: 3500,
  },
  {
    id: 2,
    title: "Deluxe Triple Bedded Room",
    subtitle: "3 adults",
    img: "/03.webp",
    description: "Our spacious three-bedded room, located in a heritage hotel at Chowrasta, combines classic charm with modern amenities. Overlooking the hotel’s lush gardens, the room offers a tranquil retreat, blending vintage furnishings with contemporary comforts. Perfectly situated in the town square, it provides both elegance and convenience.",
    amenities: [
      "Comfortable beds with fresh linens",
      "Clean blankets & pillows",
      "Attached bathroom with hot & cold running water",
      "Basic toiletries",
      "Television",
      "Free Wi-Fi",
      "Electric kettle (for boiling water only)",
      "Complimentary drinking water",
      "Rooms with views (mall road / garden / hill – subject to availability)",
      "Daily housekeeping",
      "Room heater available (on request / chargeable)"
    ],
    images: ["/03.webp", "/231.webp", "/102.webp", "/toilet.webp", "/2000.webp", "/2001.webp", "/2002.webp"],
    detailedDescription: [
      "Our spacious three-bedded room, located in a heritage hotel at Chowrasta, combines classic charm with modern amenities. Overlooking the hotel’s lush gardens, the room offers a tranquil retreat, blending vintage furnishings with contemporary comforts. Perfectly situated in the town square, it provides both elegance and convenience."
    ],
    price: 4500,
  },
  {
    id: 3,
    title: "Deluxe Quadruple Room",
    subtitle: "4 adults",
    img: "/dbl-del-quad/ddq3.webp",
    description: "Our cozy three-bedded room, nestled in the heart of Chowrasta, offers a welcoming retreat with vintage charm and modern comforts. Surrounded by lush gardens, it’s a peaceful haven for families or small groups. With its warm ambiance and prime location, it’s the perfect place to relax and unwind.",
    amenities: [
      "Comfortable beds with fresh linens",
      "Clean blankets & pillows",
      "Attached bathroom with hot & cold running water",
      "Basic toiletries",
      "Television",
      "Free Wi-Fi",
      "Electric kettle (for boiling water only)",
      "Complimentary drinking water",
      "Rooms with views (mall road / garden / hill – subject to availability)",
      "Daily housekeeping",
      "Room heater available (on request / chargeable)"
    ],
    images: [
      "/dbl-del-quad/ddq1.webp",
      "/dbl-del-quad/ddq2.webp",
      "/dbl-del-quad/ddq3.webp",
      "/dbl-del-quad/ddq4.webp",
      "/dbl-del-quad/ddq5.webp"
    ],
    detailedDescription: [
      "Our cozy three-bedded room, nestled in the heart of Chowrasta, offers a welcoming retreat with vintage charm and modern comforts. Surrounded by lush gardens, it’s a peaceful haven for families or small groups. With its warm ambiance and prime location, it’s the perfect place to relax and unwind."
    ],
    price: 5500,
  },
  {
    id: 4,
    title: "Superior Quadruple Room",
    subtitle: "4 adults",
    img: "/superior-quad-rooms/sqr1.webp",
    description: "Our cozy three-bedded room, nestled in the heart of Chowrasta, offers a welcoming retreat with vintage charm and modern comforts. Surrounded by lush gardens, it’s a peaceful haven for families or small groups. With its warm ambiance and prime location, it’s the perfect place to relax and unwind.",
    amenities: [
      "Comfortable beds with fresh linens",
      "Clean blankets & pillows",
      "Attached bathroom with hot & cold running water",
      "Basic toiletries",
      "Television",
      "Free Wi-Fi",
      "Electric kettle (for boiling water only)",
      "Complimentary drinking water",
      "Rooms with views (mall road / garden / hill – subject to availability)",
      "Daily housekeeping",
      "Room heater available (on request / chargeable)"
    ],
    images: ["/superior-quad-rooms/sqr1.webp", "/superior-quad-rooms/sqr2.webp", "/superior-quad-rooms/sqr3.webp", "/superior-quad-rooms/sqr4.webp"],
    detailedDescription: [
      "Our cozy three-bedded room, nestled in the heart of Chowrasta, offers a welcoming retreat with vintage charm and modern comforts. Surrounded by lush gardens, it’s a peaceful haven for families or small groups. With its warm ambiance and prime location, it’s the perfect place to relax and unwind."
    ],
    price: 5500,
  },
  {
    id: 5,
    title: "Superior Double Bedded Room",
    subtitle: "2 adults",
    img: "/superior-double-bedded-room/sdbr1.webp",
    description: "This elegant two-bedded room at our heritage hotel, nestled in the heart of Chowrasta, offers timeless charm with vintage furnishings and modern amenities. Overlooking the hotel’s lush gardens, the room combines historic elegance with serene comfort, providing a peaceful retreat in the vibrant town center.",
    amenities: [
      "Comfortable beds with fresh linens",
      "Clean blankets & pillows",
      "Attached bathroom with hot & cold running water",
      "Basic toiletries",
      "Television",
      "Free Wi-Fi",
      "Electric kettle (for boiling water only)",
      "Complimentary drinking water",
      "Rooms with views (mall road / garden / hill – subject to availability)",
      "Daily housekeeping",
      "Room heater available (on request / chargeable)"
    ],
    images: [
      "/superior-double-bedded-room/sdbr1.webp",
      "/superior-double-bedded-room/sdbr2.webp",
      "/superior-double-bedded-room/sdbr3.webp",
      "/superior-double-bedded-room/sdbr4.webp",
      "/superior-double-bedded-room/sdbr5.webp",
      "/superior-double-bedded-room/sdbr6.webp",
      "/superior-double-bedded-room/sdbr7.webp",
      "/superior-double-bedded-room/sdbr8.webp",
      "/superior-double-bedded-room/sdbr9.webp"
    ],
    detailedDescription: [
      "This elegant two-bedded room at our heritage hotel, nestled in the heart of Chowrasta, offers timeless charm with vintage furnishings and modern amenities. Overlooking the hotel’s lush gardens, the room combines historic elegance with serene comfort, providing a peaceful retreat in the vibrant town center."
    ],
    price: 3500,
  },
];

export const getRoomById = (id) => {
  return rooms.find(room => room.id === parseInt(id));
};